export default "__VITE_ASSET__qTyryckz__"